export const originalPackages = [
  {
    id: 'python',
    title: 'Python',
    img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
    pricing: { IN: '₹499' },
  },
  {
    id: 'dsa-python',
    title: 'DSA in Python',
    img: '/Assets/navIcons/coursesNavIcons/DSAPythonIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSAPythonIconWhite.svg',
    pricing: { IN: '₹2499' },
  },
  {
    id: 'dsa',
    title: 'DSA in C',
    img: '/Assets/navIcons/coursesNavIcons/DSACIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACIconWhite.svg',
    pricing: { IN: '₹2499' },
  },
  {
    id: 'dsa-java',
    title: 'DSA in Java',
    img: '/Assets/navIcons/coursesNavIcons/DSAJavaIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSAJavaIconWhite.svg',
    pricing: { IN: '₹2499' },
  },
  {
    id: 'dsa-cpp',
    title: 'DSA in C++',
    img: '/Assets/navIcons/coursesNavIcons/DSACppIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACppIconWhite.svg',
    pricing: { IN: '₹2499' },
  },
  {
    id: 'dsa-js',
    title: 'DSA in JavaScript',
    img: '/Assets/navIcons/coursesNavIcons/DSAJsIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSAJsIconWhite.svg',
    pricing: { IN: '₹2499' },
  },
  {
    id: 'dsa-cs',
    title: 'DSA in C#',
    img: '/Assets/navIcons/coursesNavIcons/DSACSharpIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACSharpIconWhite.svg',
    pricing: { IN: '₹2499' },
  },
  {
    id: 'c-programming',
    title: 'C & Pointers',
    img: '/Assets/navIcons/coursesNavIcons/CPrgIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CPrgIconWhite.svg',
    pricing: { IN: '₹799' },
  },
  {
    id: 'data-analysis',
    title: 'Data Analysis',
    img: '/Assets/navIcons/partnersNavIcons/ExcelIcon.svg',
    whiteImg: '/Assets/navIcons/partnersNavIconsWhite/ExcelIconWhite.svg',
    pricing: { IN: '₹1499' },
  },
  {
    id: 'frontend-development',
    title: 'Frontend Development',
    img: '/Assets/navIcons/coursesNavIcons/HTMLIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/HTMLIconWhite.svg',
    pricing: { IN: '₹1299' },
  },
  {
    id: 'interview',
    title: 'Interview Preparation',
    img: '/Assets/navIcons/coursesNavIcons/InterviewPatternIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/InterviewPatternIconWhite.svg',
  },
  {
    id: 'selenium',
    title: 'Selenium',
    img: '/Assets/navIcons/coursesNavIcons/SeleniumIcon.svg',
    whiteImg: '/Assets/navIcons/coursesNavIconsWhite/SeleniumIconWhite.svg',
  },
];
